exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.sorting[data-v-829d3108] {\n\t\tposition: absolute;\n\t\tleft: 319px;\n\t\tz-index: 1000;\n\t\twidth: 200px;\n}\n#addUser[data-v-829d3108]{\n\tmargin-bottom: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-829d3108","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/trip/UpComingTrip.vue
// module id = 213
// module chunks = 0